module.exports = "/assets/e284aa4a30238437856fd503f582e252.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JJ.png
// module id = 2636
// module chunks = 0